@let setPasswordError = error();
@if (tenantStore.id() && !setPasswordError) {
  <shared-form-header [formTitle]="tenantStore.name()">
    <div form-content>
      <shared-set-password-form (setPassword)="setPassword($event)" />
    </div>
  </shared-form-header>
} @else {
  @if (setPasswordError) {
    <div class="error-wrapper">
      <orbit-message
        [message]="setPasswordError!!"
        [title]="'SHARED.PAGES.LOGIN.ERROR_TITLE' | translate"
        [severity]="'error'"
        [titleTestId]="'error-set-password-title-main'"
        [messageTestId]="'error-set-password-message-main'" />
      <a id="forgot-password" href="/reset-password">
        {{ 'SHARED.PAGES.SET_PASSWORD.GET_NEW_RESET_LINK' | translate }}
      </a>
    </div>
  } @else {
    @let errors = tenantErrors();
    @if (errors && errors.length > 0 && errors[0]) {
      @let error = errors[0];
      <shared-global-error
        [message]="error.message ?? error.code | translate"
        [unknownError]="false"
        [hasReload]="false" />
    } @else {
      <orbit-fa-icon class="loading-icon" [iconName]="spinnerIcon" animation="spin" iconSize="2x" />
    }
  }
}
